import React from 'react';
import './FuelFleet.css';
import FMSimage from '../Assets/Picture1 fleet3.jpg'; // First image
import FMSimage2 from '../Assets/fleet111.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/fleet2.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/fleet.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/fleet5.png'; // Image for Industries section

const Fleet = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">FUEL AND FLEET MANAGEMENT SYSTEM</h1>
                        <p className="FMS-description">
                            The Fuel and Fleet Management System from Vajra IoT optimizes fuel usage and fleet operations by tracking travel distance, KMPL, trip distance, and driver performance. With real-time fuel level monitoring and advanced analytics, it reduces fuel pilferage, enhances efficiency, and provides actionable insights for cost savings.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Fuel and Fleet Management System" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Travel Distance Measurement:</strong> Tracks total distance traveled by vehicles.</li>
                                <li><strong>KMPL Measurement:</strong> Monitors kilometers per liter for fuel efficiency.</li>
                                <li><strong>Trip Distance:</strong> Records distance for individual trips.</li>
                                <li><strong>Driver-Based KMPL:</strong> Analyzes fuel efficiency per driver for performance insights.</li>
                                <li><strong>Live Reports:</strong> Provides real-time data on fuel and fleet performance.</li>
                                <li><strong>Fuel Usage Insights:</strong> Offers advanced analytics to optimize consumption.</li>
                                <li><strong>Fuel Pilferage Reduction:</strong> Detects and prevents fuel theft.</li>
                                <li><strong>Real-Time Alarms:</strong> Sends notifications for anomalies like theft or overuse.</li>
                                <li><strong>Fuel Level Measurement:</strong> Monitors tank levels in real time.</li>
                                <li><strong>Fuel Usage Analytics:</strong> Generates detailed reports for cost management.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: New Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Sensors installed in vehicles measure fuel levels, travel distance, trip distance, and KMPL, with driver-specific data for performance tracking. Data is transmitted wirelessly to a centralized platform, generating live reports and analytics. Real-time alarms notify users of fuel theft or inefficiencies, while detailed reports provide insights for better fuel management.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Fuel and Fleet Management System</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Fuel Theft Prevention:</strong> Real-time monitoring and alarms reduce pilferage.</li>
                                <li><strong>Cost Savings:</strong> Optimizes fuel usage with KMPL and trip data insights.</li>
                                <li><strong>Driver Performance:</strong> Tracks driver-based KMPL for accountability.</li>
                                <li><strong>Real-Time Insights:</strong> Live reports and notifications ensure proactive management.</li>
                                <li><strong>Comprehensive Analytics:</strong> Detailed fuel usage reports drive efficiency.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Fuel Management" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our System */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our Fuel and Fleet Management System</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using Fuel Management" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Fuel and Fleet Management System is trusted by a variety of industries to optimize fuel usage and enhance operational efficiency. These industries rely on our solution for its accuracy, reliability, and cost-saving benefits:
                            <ul>
                                <li>Logistics & Transportation</li>
                                <li>Construction & Heavy Equipment</li>
                                <li>Smart Cities</li>
                                <li>Industrial Fleet Operations</li>
                                <li>Oil & Gas Industry</li>
                                <li>Public Transport Services</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fleet;